module.exports = __webpack_public_path__ + "static/media/TeacherContent1.9951fca7.svg";